<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let credits = []

    $: if (dateStart && dateEnd)
        getCreditsLatest()

    function formatPayment(payment) {
        return Moment(payment).locale('es').format('DD MMM YYYY h:mm A')
    }

    async function getCreditsLatest() {
        loading = true
        credits = []

        const resp = await StatisticsService.getCreditsLatest({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        credits = resp.data?.credits ?? []
    }

</script>

<style>
    .credits-list {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .credits-list__item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.85rem 0;
        border-bottom: 1px solid #eee;
    }

    .credits-list__item:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .credits-list__item:first-child {
        padding-top: 0;
    }

    .credits-list__icon {
        flex-shrink: 0;
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        background: rgba(9, 142, 55, 0.1);
        color: var(--color-primary, #098E37);
        font-size: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .credits-list__info {
        flex: 1;
        min-width: 0;
    }

    .credits-list__title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 2px;
    }

    .credits-list__meta {
        font-size: 12px;
        color: #a0a0a0;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .credits-list__amount {
        flex-shrink: 0;
        font-size: 15px;
        font-weight: 700;
        color: var(--color-primary, #098E37);
    }
</style>

<StatsCard icon="fa-wallet" meta="Créditos" title="Últimas recargas" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && credits.length}
            <ul class="credits-list">
                {#each credits as credit}
                    <li class="credits-list__item">
                        <span class="credits-list__icon"><i class="fas fa-wallet"></i></span>
                        <div class="credits-list__info">
                            <p class="credits-list__title">{ credit.user?.name ?? '—' }</p>
                            <p class="credits-list__meta">
                                { credit.user?.email ?? '—' } · { formatPayment(credit.payment) }
                            </p>
                        </div>
                        <span class="credits-list__amount">{ NumeralMethods.cash(credit.amount) }</span>
                    </li>
                {/each}
            </ul>
        {:else if !loading}
            <p class="empty">Sin recargas en el periodo seleccionado</p>
        {/if}
    </div>
</StatsCard>
